(function () {
  'use strict';
  var box = document.querySelector('[data-cart-rate-estimator]');
  if (!box) return;
  var country = box.querySelector('[data-rate-country]');
  var province = box.querySelector('[data-rate-province]');
  var provinceWrap = box.querySelector('[data-rate-province-wrap]');
  var zip = box.querySelector('[data-rate-zip]');
  var button = box.querySelector('[data-rate-submit]');
  var status = box.querySelector('[data-rate-status]');
  var results = box.querySelector('[data-rate-results]');
  var revision = 0, controller;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function invalidate(message) {
    revision++;
    if (controller) controller.abort();
    results.replaceChildren(); status.textContent = message || '';
    button.disabled = false; button.textContent = 'Calculate shipping';
    box.removeAttribute('aria-busy');
  }
  function provinces() {
    province.replaceChildren();
    var option = country.options[country.selectedIndex];
    var list = option ? JSON.parse(option.dataset.provinces || '[]') : [];
    list.forEach(function (pair) {
      var item = document.createElement('option'); item.value = pair[0]; item.textContent = pair[1]; province.appendChild(item);
    });
    provinceWrap.hidden = !list.length;
    if (province.dataset.default && list.some(function (pair) { return pair[0] === province.dataset.default; })) province.value = province.dataset.default;
    province.dataset.default = '';
  }
  if (Array.from(country.options).some(function (option) { return option.value === country.dataset.default; })) country.value = country.dataset.default;
  provinces();
  country.addEventListener('change', function () { provinces(); invalidate(); });
  province.addEventListener('change', function () { invalidate(); });
  zip.addEventListener('input', function () { invalidate(); });
  zip.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') { event.preventDefault(); button.click(); }
  });
  document.addEventListener('textual:cart-updated', function () { invalidate('Your cart changed. Calculate shipping again for updated rates.'); });
  function errorText(data) {
    if (typeof data.description === 'string') return data.description;
    return Object.entries(data).map(function (pair) { return pair[0].replace(/_/g, ' ') + ': ' + (Array.isArray(pair[1]) ? pair[1].join(', ') : String(pair[1])); }).join('. ');
  }
  button.addEventListener('click', async function () {
    if (!country.value) { status.textContent = 'Choose your country.'; country.focus(); return; }
    if (!zip.value.trim()) { status.textContent = 'Enter your ZIP or postal code.'; zip.focus(); return; }
    invalidate();
    var current = revision;
    var active = new AbortController(); controller = active;
    var timeout = setTimeout(function () { active.abort(); }, 20000);
    button.disabled = true; button.textContent = 'Calculating…'; box.setAttribute('aria-busy', 'true');
    status.textContent = 'Checking shipping options…';
    var params = new URLSearchParams();
    params.set('shipping_address[country]', country.value);
    params.set('shipping_address[zip]', zip.value.trim());
    if (!provinceWrap.hidden) params.set('shipping_address[province]', province.value);
    async function fetchRates(path, method) {
      var response = await fetch(root + path + '?' + params.toString(), { method: method, signal: active.signal, cache: 'no-store', headers: { 'Accept': 'application/json' } });
      var data = await response.json();
      if (!response.ok) throw new Error(response.status === 429 ? 'Shipping estimates are busy. Please try again shortly.' : errorText(data || {}) || 'Unable to calculate shipping. Please check your address.');
      return data;
    }
    try {
      await fetchRates('cart/prepare_shipping_rates.json', 'POST');
      var data = null;
      for (var attempt = 0; attempt < 15; attempt++) {
        if (current !== revision) return;
        data = await fetchRates('cart/async_shipping_rates.json', 'GET');
        if (data !== null) break;
        await new Promise(function (resolve) { setTimeout(resolve, 750); });
      }
      if (current !== revision) return;
      if (!data || !Array.isArray(data.shipping_rates)) throw new Error('Shipping rates are taking longer than expected. Please try again.');
      status.textContent = data.shipping_rates.length ? 'Estimated shipping options:' : 'No shipping rates are available for this address. Check the destination and try again.';
      data.shipping_rates.forEach(function (rate) {
        var item = document.createElement('li');
        var price = Number(rate.price);
        var amount = price === 0 ? 'Free' : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: rate.currency || box.dataset.currency || 'USD' }).format(price);
        item.textContent = (rate.presentment_name || rate.name) + ' — ' + amount;
        results.appendChild(item);
      });
    } catch (error) {
      if (current === revision) status.textContent = error.name === 'AbortError' ? 'Shipping rates are taking longer than expected. Please try again.' : error.message;
    } finally {
      clearTimeout(timeout);
      if (current === revision) { button.disabled = false; button.textContent = 'Calculate shipping'; box.removeAttribute('aria-busy'); }
    }
  });
}());
